// @module Tavanoteam.MyList.MyList
define('MyList.View'
	, [
		'Utils'
		, 'Profile.Model'
		, 'MyAccountMenu'

		, 'tavanoteam_mylist_mylist.tpl'

		, 'Backbone'
		, 'underscore'
	]
	, function (
		Utils
		, ProfileModel
		, MyAccountMenu

		, tavanoteam_mylist_mylist_tpl

		, Backbone
		, _
	) {
		'use strict';

		// @class Tavanoteam.MyList.MyList.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavanoteam_mylist_mylist_tpl

			, initialize: function (options) {
				this.debounced_render = _.debounce(_.bind(this.render, this), 250);
				this.environmentComponent = options.container.getComponent('Environment');

				MyAccountMenu.getInstance()
					.getEmitter()
					.on('entriesChanged', this.debounced_render);
			}

			, render: function () {
				this._render();

				var parent = this.$('a[name="My List"]').parent('div'),
					contents = parent.contents();

				parent.replaceWith(contents);

				if (this.$('.header-menu-myaccount-level3-orders').children().length === 1) {
					// All children menu of the order section have been removed (lack of permissions)
					// and only the back options is present
					this.$('.header-menu-myaccount-level2-orders').remove();
				}
			}

			, destroy: function () {
				MyAccountMenu.getInstance()
					.getEmitter()
					.off('entriesChanged', this.debounced_render);
				this._destroy();
			}

			//@method getContext @return Tavanoteam.MyList.MyList.View.Context
			, getContext: function getContext() {
				//@class Tavanoteam.MyList.MyList.View.Context
				var entries = _.find(MyAccountMenu.getInstance().getEntries(), function (entry) {
					return entry.name == "My Lists";
				});

				var profile = ProfileModel.getInstance(),
					isLoggedIn = profile.get('isLoggedIn') === 'T' ? true : false;

				return {
					entries: entries,
					isPhoneDevice: Utils.isPhoneDevice(),
					isLoggedIn: isLoggedIn
				};
			}
		});
	});
